import { z } from "zod";
import { StripeCustomerId, StripeInvoiceId, StripePaymentMethodId, UserIdSchema, UUIDSchema } from "./branded.js";
// Available tiers for purchase (excludes free)
export const PURCHASABLE_TIERS = ["pro"];
export const StripePriceConfigSchema = z.object({
    free: z.object({
        priceId: z.null(),
        features: z.array(z.string()),
    }),
    pro: z.object({
        priceId: z.string(),
        features: z.array(z.string()),
    }),
});
export const BillingInvoiceSchema = z.object({
    id: UUIDSchema,
    userId: UserIdSchema,
    stripeInvoiceId: z.string().transform((val) => StripeInvoiceId(val)),
    stripeCustomerId: z.string().transform((val) => StripeCustomerId(val)),
    status: z.enum(["draft", "open", "paid", "void", "uncollectible"]),
    amountPaid: z.number(),
    currency: z.string().default("usd"),
    invoicePdf: z.string().optional(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const PaymentMethodSchema = z.object({
    id: UUIDSchema,
    userId: UserIdSchema,
    stripePaymentMethodId: z.string().transform((val) => StripePaymentMethodId(val)),
    type: z.string(),
    last4: z.string().optional(),
    brand: z.string().optional(),
    expMonth: z.number().optional(),
    expYear: z.number().optional(),
    isDefault: z.boolean().default(false),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const SubscriptionEventSchema = z.object({
    id: UUIDSchema,
    stripeEventId: z.string(),
    eventType: z.string(),
    customerId: z
        .string()
        .optional()
        .transform((val) => (val ? StripeCustomerId(val) : undefined)),
    subscriptionId: z.string().optional(),
    processed: z.boolean().default(false),
    eventData: z.record(z.string(), z.any()),
    createdAt: z.date(),
});
// Stripe webhook event types we handle
export const STRIPE_WEBHOOK_EVENTS = [
    "customer.subscription.created",
    "customer.subscription.updated",
    "customer.subscription.deleted",
    "customer.subscription.trial_will_end",
    "invoice.payment_succeeded",
    "invoice.payment_failed",
    "payment_method.attached",
    "payment_method.detached",
];
//# sourceMappingURL=billing.js.map